import { PropsWithChildren } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { clsx } from 'clsx';
import s from './ControlledCheckbox.module.scss';
import { IWithClassname } from '@/models/common';

interface Props extends PropsWithChildren, IWithClassname {
  fieldName: string;
}

export const ControlledCheckbox = ({ fieldName, className, children }: Props) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={fieldName}
      control={control}
      render={({ field: { value, onChange }, fieldState: { error } }) => (
        <label className={clsx(s.checkbox, className)}>
          <div className={s.checkbox__inner}>
            <div className={clsx(s.checkbox__mark, { [s.checkbox__mark_checked]: value })}>
              <input type="checkbox" onChange={onChange} />
            </div>
            <div className={s.checkbox__text}>{children}</div>
          </div>
          <span className={clsx(s.checkbox__error, { [s.checkbox__error_visible]: error })}>
            {error?.message}
          </span>
        </label>
      )}
    />
  );
};